import React, { useContext } from 'react';

import CreateKeyValueInput from '../../../../../Components/CreateKeyValueInput';
import ValueInput from '../../../../../Components/ValueInput';
import constants from '../constants.json';

import { validGamUprFloorValues } from '../../../../../core/constants/gamUprConstants';
import { countryCodesList, COUNTRY_CODE_MAP, PLATFORMS } from '../../../../../core/constants';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';

//mui imports====
import { Grid } from '@mui/material';
//===============

const OsLevelGamUprConfig = ({ keyData, platform, operatingSystem }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const { gamUprPlatforms } = constants;
	const hasDefaultPlatformFloorMapping = !!(
		platform === gamUprPlatforms.DEFAULT &&
		rawConfig[keyData]?.[platform]?.[operatingSystem]?.countryWiseFloorMapping?.DEFAULT
	);

	const gamUprPlatformObject =
		rawConfig[keyData]?.[platform]?.[operatingSystem]?.countryWiseFloorMapping || {};

	/**
	 * @name updatePlatformObjectToGamUpr
	 * @description The function takes the updatedPlatformObject and updates this platform Object to the rawConfig
	 * @param {Object} newPlatformObject - It is the updated platform object which can be updated to rawConfig with the specific platform.
	 */
	const updatePlatformObjectToGamUpr = (newPlatformObject) => {
		if (rawConfig && keyData && platform && operatingSystem) {
			let updatedObject = structuredClone(rawConfig);
			if (!updatedObject[keyData]) {
				updatedObject[keyData] = {};
			}

			if (!updatedObject[keyData][platform]) {
				updatedObject[keyData][platform] = {};
			}

			if (!updatedObject[keyData][platform][operatingSystem]) {
				updatedObject[keyData][platform][operatingSystem] = {};
			}
			updatedObject[keyData][platform][operatingSystem].countryWiseFloorMapping = newPlatformObject;
			updateRawConfig(updatedObject);
		} else {
			alert(
				'The Raw Config or the selected Gam Upr platform and operating system is missing in the configuration.'
			);
		}
	};

	/**
	 * @name gamUprOptions
	 * @description This function options for ValueInput component from the floors present in validGamUprFloorValues
	 * @return {object[]} the gam Upr valid options array is returned from the function
	 */
	const gamUprOptions = () => {
		const gamUprValidOptionsArray = validGamUprFloorValues.map((floor) => {
			return { label: floor, value: floor };
		});

		return gamUprValidOptionsArray;
	};

	/**
	 * @name getKeysNotPresentInGamUprObject
	 * @description This function returns the countryCode which are not present in gamUprPlatformObject
	 * @return {array} it returns the available keys which can be added and not present in gamUprPlatformObject
	 */
	const getKeysNotPresentInGamUprObject = () => {
		// If the platform is DEFAULT then ["DEFAULT"] value will return.
		if (platform === gamUprPlatforms.DEFAULT) {
			return [{ label: countryCodesList[0], value: countryCodesList[0] }];
		}
		const availableKeys = countryCodesList.filter(
			(keyValue) => !Object.keys(gamUprPlatformObject).includes(keyValue)
		);
		const formattedKeys = availableKeys.map((key) => {
			return {
				label: `${COUNTRY_CODE_MAP?.[key] || key} (${key})`,
				value: key
			};
		});

		return formattedKeys;
	};
	return (
		<Grid container spacing={5}>
			{Object.keys(gamUprPlatformObject).map((key) => {
				return (
					<Grid item xs={12} sm={12} lg={6} md={12} key={key}>
						<ValueInput
							keyValue={key}
							isObjectEditor={false}
							object={gamUprPlatformObject}
							updateObject={updatePlatformObjectToGamUpr}
							isAutoCompleteRequired={true}
							options={gamUprOptions()}
							generateLabel={(code) => `${COUNTRY_CODE_MAP?.[code] || code} (${code})`}
							valueType="string"
							containerStyle={{
								display: 'flex',
								justifyContent: 'flex-start',
								width: 'fit-content',
								alignItems: 'center'
							}}
						/>
					</Grid>
				);
			})}
			<Grid item xs={6}>
				<CreateKeyValueInput
					keyList={getKeysNotPresentInGamUprObject()}
					valueType="string"
					isObjectEditor={false}
					isAutoCompleteRequired={true}
					object={gamUprPlatformObject}
					updateObject={updatePlatformObjectToGamUpr}
					disabled={hasDefaultPlatformFloorMapping}
					options={gamUprOptions()}
					selectKeyDefaultWidth={'165px'}
					containerStyle={{
						display: 'flex',
						alignItems: 'center'
					}}
				/>
			</Grid>
		</Grid>
	);
};

export default OsLevelGamUprConfig;
